import React, { useEffect, useState, useContext } from "react";
import "../styles/manageUsers.css";
import $ from "jquery";
import LoadingIcon from "../images/Loading_icon.gif";
import UserRow from "../components/ManageUsers/UserRow";
import { UserContext } from "../contexts/UserContext";
import CreateUser from "./CreateUser";
import SelectImage from "../components/ManageUsers/UserLogo";
import { UrlContext } from "../contexts/UrlContext";

export default function ManageUsers() {
  useEffect(() => {
    document.title = "Manage Users";
  }, []);
  const { API_URL } = useContext(UrlContext);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { userData, userError, adminUser } = useContext(UserContext);
  const [showCreateUser, setShowCreateUser] = useState(false);
  const [showSelectImage, setShowSelectImage] = useState(false);
  const [dataForImageUpload, setDataForImageUpload] = useState(null);

  useEffect(() => {
    const url = `${API_URL}get-all-users`;
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        setData(data.users);
        setLoading(false);
        console.log("user", userData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <>
      <div className="container-div">
        <div className="delete-user-div">
          <h3>Manage Users</h3>
          {adminUser ? (
            <div className="rightBar">
              <button
                className="createUserBtn"
                title="Create User"
                onClick={() => {
                  $(".uploadLogo1-popup-wrapper").fadeIn();
                  console.log(userData);
                  setShowCreateUser(true);
                }}
              >
                <i className="fa-solid fa-plus"></i> Create User
              </button>
            </div>
          ) : (
            <></>
          )}

          {showCreateUser ? (
            <>
              {/*---------------------- upload logo1 popup -----------------------*/}
              <div className="createUser-wrapper">
                <div className="container-div">
                  <CreateUser setShowCreateUser={setShowCreateUser} />
                </div>
              </div>
            </>
          ) : (
            <></>
          )}

          {loading ? (
            <img
              className="delete-user-loading"
              src={LoadingIcon}
              alt="Loading..."
            />
          ) : (
            <table className="table delete-user-table">
              <thead>
                <tr>
                  <th></th>
                  <th>Username</th>
                  <th>Full Name</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Status</th>
                  {adminUser ? <th>Modify</th> : <></>}
                  {adminUser ? <th>Delete</th> : <></>}
                </tr>
              </thead>

              <tbody>
                {data &&
                  data.map((user, index) => (
                    <UserRow
                      user={user}
                      key={index}
                      adminUser={adminUser}
                      currentUser={userData}
                      setShowSelectImage={setShowSelectImage}
                      setDataForImageUpload={setDataForImageUpload}
                    />
                  ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
      {showSelectImage ? (
        <SelectImage
          showSelectImage={showSelectImage}
          dataForImageUpload={dataForImageUpload}
        />
      ) : null}
    </>
  );
}
